export default class Table {
	static init() {
		if (document.body.classList.contains('neos-backend')) {
			return;
		}
		Array.prototype.forEach.call(document.querySelectorAll('.neos-text-free table'), el => {
			new Table(el);
		});
	}

	wrap(el, wrapper) {
		el.parentNode.insertBefore(wrapper, el);
		wrapper.appendChild(el);
	}

	constructor(element) {
		if (!element) return;
		let heading;

		for (let columnIndex = 0; columnIndex < element.querySelectorAll('thead th').length; columnIndex++) {
			let rows = element.querySelectorAll('tbody tr');
			for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
				heading = '<span class="table__heading">' + element.querySelectorAll('thead th')[columnIndex].innerHTML + '</span>'
				let td = rows[rowIndex].querySelectorAll('th,td')[columnIndex];
				if (td.tagName !== 'th') {
					td.innerHTML = heading + td.innerHTML;
				}
			}
		}

		let arrows = document.createElement("DIV");
		this.arrowLeft = document.createElement("BUTTON");
        this.arrowRight = document.createElement("BUTTON");
		let responsiveWrapper = document.createElement("DIV");

		arrows.classList.add('responsive-element__arrows');
        this.arrowLeft.classList.add('responsive-element__arrow', 'responsive-element__arrow--left', 'responsive-element__arrow--is-hidden');
        this.arrowRight.classList.add('responsive-element__arrow', 'responsive-element__arrow--right');
		responsiveWrapper.classList.add('responsive-element');

		arrows.appendChild(this.arrowLeft);
		arrows.appendChild(this.arrowRight);

		if (element.parentElement.classList.contains('table')) {
            this.wrapper = element.parentElement;
		} else {
            this.wrapper = document.createElement("FIGURE");
            this.wrapper.classList.add('table');

			this.wrap(element, this.wrapper);
		}

		this.wrap(this.wrapper, responsiveWrapper);
		responsiveWrapper.appendChild(arrows);

        this.arrowLeft.addEventListener('click', (e) => {
            this.wrapper.scrollTo({
				top: 0,
				left: this.wrapper.scrollLeft - responsiveWrapper.getBoundingClientRect().width,
				behavior: 'smooth'
			});
		});

        this.arrowRight.addEventListener('click', (e) => {
            this.wrapper.scrollTo({
				top: 0,
				left: this.wrapper.scrollLeft + responsiveWrapper.getBoundingClientRect().width,
				behavior: 'smooth'
			});
		});

        // show hide arrows (initial, resize, scroll)
        this.showHideArrows();

        this.wrapper.addEventListener('scroll', e => {
            this.showHideArrows();
		});

        window.addEventListener('resize', e => {
            this.showHideArrows();
        });
	}

    showHideArrows(){
        let width = Math.round(this.wrapper.querySelector('table').getBoundingClientRect().width);
        let scrolled = Math.round(this.wrapper.scrollLeft + this.wrapper.getBoundingClientRect().width);
        this.arrowRight.classList[scrolled >= width ? 'add' : 'remove']('responsive-element__arrow--is-hidden');
        this.arrowLeft.classList[this.wrapper.scrollLeft <= 0 ? 'add' : 'remove']('responsive-element__arrow--is-hidden');
    }
}
